document.addEventListener('DOMContentLoaded', () => {
  /*STICKY HEADER */
  const header = document.querySelector('.custom-header');
  if (header && header.classList.contains('sticky-enabled')) {
    const handleScroll = () => {
      if (window.scrollY > 120 && window.innerWidth > 1025) {
        header.classList.add('fixed');
      } else {
        header.classList.remove('fixed');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    handleScroll();
  }

  //community-review-section
  if (document.querySelector('.text-swiper')) {
    new Swiper(".text-swiper", {
      loop: true,
      autoHeight: true,
      slidesPerView: "auto",
      speed: 600,
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
    });
  }

  //community-education-section
  if (document.querySelector('.champions-slider')) {
    new Swiper(".champions-slider", {
      loop: true,
      slidesPerView: "auto",
      speed: 600,
      autoHeight: true,
      navigation: {
        nextEl: ".champions-section .next-btn",
        prevEl: ".champions-section .prev-btn",
      },
    });
  }

  // Commnunity FAQ's
  const items = document.querySelectorAll('.faq-image-section .faq-item');
  if (items.length) {
    items.forEach(item => {
      const btn = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      if (item.classList.contains('active')) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }

      btn.addEventListener('click', () => {
        items.forEach(i => {
          if (i !== item) {
            i.classList.remove('active');
            i.querySelector('.faq-answer').style.maxHeight = null;
          }
        });

        item.classList.toggle('active');

        answer.style.maxHeight = item.classList.contains('active')
          ? answer.scrollHeight + 'px'
          : null;
      });
    });
  }

  // Shop page add to cart drawer open start
  document.querySelectorAll('.product-slider').forEach(slider => {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 5,
      speed: 500,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      }
    });
  });


  const updateHeaderCartCount = () => {
    return fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const cartIcon = document.querySelector('#cart-icon-bubble');

        if (!cartIcon) return;

        let bubble = cartIcon.querySelector('.cart-count-bubble');

        if (cart.item_count > 0) {
          if (!bubble) {
            cartIcon.insertAdjacentHTML(
              'beforeend',
              `
            <div class="cart-count-bubble">
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">
                ${cart.item_count} items
              </span>
            </div>
            `
            );
          } else {
            const countSpan = bubble.querySelector('[aria-hidden="true"]');

            if (countSpan) {
              countSpan.textContent = cart.item_count;
            }
          }
        } else if (bubble) {
          bubble.remove();
        }
      });
  };

  const addToCart = (variantId) => {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(() => fetch('/?sections=cart-drawer'))
      .then((res) => res.json())
      .then((sections) => {

        const html = new DOMParser().parseFromString(
          sections['cart-drawer'],
          'text/html'
        );

        const sourceDrawer =
          html.querySelector('#CartDrawer') ||
          html.querySelector('cart-drawer');

        const targetDrawer =
          document.querySelector('#CartDrawer') ||
          document.querySelector('cart-drawer');

        if (sourceDrawer && targetDrawer) {
          targetDrawer.innerHTML = sourceDrawer.innerHTML;
        }

        return updateHeaderCartCount();
      })
      .then(() => {
        document.body.classList.add('overflow-hidden');

        const themeCart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (themeCart) {
          themeCart.classList.remove('is-empty');

          if (typeof themeCart.open === 'function') {
            themeCart.open();
          } else {
            themeCart.classList.add('active');
          }
        }
      });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('loading')) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const originalHTML = btn.innerHTML;
    btn.classList.add('loading');
    btn.innerHTML = 'Adding...';
    addToCart(variantId)
      .catch((error) => {
        console.error('Add to cart error:', error);
      })
      .finally(() => {
        btn.classList.remove('loading');
        btn.innerHTML = originalHTML;
      });
  });
  // Shop page add to cart drawer open end


  const counters = document.querySelectorAll(".impact-number");
  const animateCounter = (counter) => {
    const target = +counter.getAttribute("data-target");
    const countElement = counter.querySelector(".count");
    const duration = 2000;
    const startTime = performance.now();
    const updateCount = (currentTime) => {
      const progress = Math.min(
        (currentTime - startTime) / duration,
        1
      );
      const currentValue = Math.floor(progress * target);
      countElement.innerText =
        currentValue.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        countElement.innerText =
          target.toLocaleString();
      }
    };
    requestAnimationFrame(updateCount);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });

  }, { threshold: 0 });
  counters.forEach(counter => {
    observer.observe(counter);
  });
  // counter end

  // FAQs page 
  const faqItems = document.querySelectorAll('.custom-faq-section .faq-main-item');

  faqItems.forEach((item) => {

    const question = item.querySelector('.faq-main-question');
    const answer = item.querySelector('.faq-main-answer');

    if (item.classList.contains('active')) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      faqItems.forEach((faq) => {
        faq.classList.remove('active');
        const faqAnswer = faq.querySelector('.faq-main-answer');
        faqAnswer.style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }

    });

  });


  // home page gallery slider
  const wrapper = document.querySelector('.mySlider .swiper-wrapper');
  if (!wrapper) return;

  let slides = wrapper.children.length;

  if (slides <= 3 && slides > 0) {
    let content = wrapper.innerHTML;
    wrapper.innerHTML += content;
    wrapper.innerHTML += content;
  }

  new Swiper('.mySlider', {
    slidesPerView: 3,
    spaceBetween: 1,
    centeredSlides: true,
    loop: slides > 1,
    speed: 600,
    slidesPerGroup: 1,
    breakpoints: {
      0: {
        slidesPerView: 1.3
      },
      568: {
        slidesPerView: 2
      },
      980: {
        slidesPerView: 3
      }
    }
  });


  // Home page community section map changed

  const buttons = document.querySelectorAll('.community-btn');
  const images = document.querySelectorAll('.community-image');

  buttons.forEach((btn) => {
    btn.addEventListener('click', function () {

      const url = this.getAttribute('data-url');

      // Redirect if URL exists
      if (url && url.trim() !== '') {
        window.location.href = url;
        return;
      }

      // Otherwise current functionality
      const index = this.getAttribute('data-index');

      buttons.forEach((b) => b.classList.remove('active'));
      images.forEach((img) => img.classList.remove('active'));

      this.classList.add('active');

      const target = document.querySelector(
        '.community-image[data-index="' + index + '"]'
      );

      if (target) {
        target.classList.add('active');
      }
    });
  });

});

